const advertiser = (state) => {
  return state.advertiser;
}

const advertiser_id = (state) => {
  return state.advertiser_id;
}

const advertisers = (state) => {
  return state.advertisers;
}

const university_advertisers = (state) => (university_id) => {
  if (university_id === -1) {
    return state.advertisers;
  }
  return state.advertisers.filter(advertiser => advertiser.university_ids.includes(university_id));
}

const getLocation = (state) => (id) => {
  for (var i = 0; i < state.advertisers.length; i++) {
    if (state.advertisers[i].id === id) {
      return state.advertisers[i];
    }
  }
  return {};
}

export default {
  advertiser,
  advertiser_id,
  advertisers,
  university_advertisers,
  getLocation,
}